
namespace RioERP.Users {

    @Serenity.Decorators.registerClass()
    //export class ProductsFranchiseeDialog extends Serenity.PropertyDialog<any, any> {
    export class CustomerEmailDialog extends Serenity.EntityDialog<CustomersRow, any> {
        protected getFormKey() { return CustomersEmailForm.formKey; }
        protected getIdProperty() { return CustomersRow.idProperty; }
        protected getLocalTextPrefix() { return CustomersRow.localTextPrefix; }
        protected getService() { return CustomersService.baseUrl; }

        protected form = new CustomersEmailForm(this.idPrefix);
        public rowids: string;

        private checkGrid: CustomersGrid;
        constructor(gridToRefresh, FormMode, rowKeys) {       
            super();

            this.form = new CustomersEmailForm(this.idPrefix);
            //debugger;
            this.rowids = rowKeys;
            this.form.RowIds.value = rowKeys;            
        }
        
        loadEntity(entity: CustomersRow) {
            super.loadEntity(entity);
            //debugger;
            this.form.RowIds.value = this.rowids;
            this.form.RowIds.getGridField().toggle(false);
        }

        protected getDialogButtons(): Serenity.DialogButton[]
        {
            return [              
                {
                    text: 'Send Email',
                    click: () => {
                        debugger;                        
                        var id = this.form.RowIds.value;
                        
                        CustomersService.SendEmails({
                            ids: this.form.RowIds.value,
                            subject: this.form.Subject.value,
                            description: this.form.Description.value,


                        }, response => {
                            Q.notifyInfo(
                                'Inserted: ' + (response.Inserted || 0));
                            Q.notifySuccess("Email sent Successfully");
                            this.dialogClose();
                        });
                    },
                },
                {
                    text: 'Cancel',
                    click: () => this.dialogClose()
                }
            ];
        }

        protected getDialogTitle(): string {
            return "Send Email";
        }
    }
}